import _pt from "prop-types";

import React from "react";
import classNames from "classnames";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

export var Typography = function Typography(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? "span" : _ref$tag,
      type = _ref.type,
      props = _objectWithoutProperties(_ref, ["children", "className", "tag", "type"]);

  return React.createElement(Tag, _extends({
    className: classNames("axiom-typography--".concat(type), className)
  }, props), children);
};
Typography.propTypes = {
  children: _pt.any,
  className: _pt.string,
  tag: _pt.any,
  type: _pt.oneOf(["body", "caption", "code", "header1", "header2", "header3", "header4", "header5", "subhead", "xs", "xxs"]).isRequired
};
Typography.displayName = "Typography";